module.exports = __webpack_public_path__ + "img/R2D2-icon.23dbe285.png";